<template>
  <div id="checkout">
    <template v-if="loading">
      <bounce-loader />
    </template>
    <template v-else>
      <thank-you-page />
      <HelpProblems :order="paidOrder" />
    </template>
  </div>
</template>

<script async>
import { isServer } from '@vue-storefront/core/helpers'
const ThankYouPage = () => import(/* webpackChunkName: "vsf-thank-you-page" */ 'theme/components/core/blocks/Checkout/ThankYouPage');
const HelpProblems = () => import(/* webpackChunkName: "vsf-help-problems" */ 'theme/components/core/blocks/Checkout/HelpProblems');
const BounceLoader = () => import(/* webpackChunkName: "vsf-bounce-loader" */ 'theme/components/theme/blocks/Home/Preloaders/BounceLoader.vue');

export default {
  components: {
    BounceLoader,
    ThankYouPage,
    HelpProblems
  },
  data () {
    return {
      image: '../assets/bg.png',
      clientAllowedRendering: false,
      loading: true,
      paidOrder: null
    }
  },
  methods: {
    renderCheckout () {
      if (!isServer) {
        let t = setTimeout(() => {
          this.clientAllowedRendering = true
          clearTimeout(t)
        }, 50)
      }
      return !isServer && this.clientAllowedRendering
    }
  },
  async mounted () {
    this.loading = true;
    if (!isServer) {
      const orders = JSON.parse(localStorage.getItem('shop/order/last-placing-orders-data'));
      if (Array.isArray(orders)) {
        this.paidOrder = orders.find(order => order.connection_order_id === this.$route.params.orderId);
        // additional_orders (present when this landing came from the original checkout's
        // combined iPay payment - see Checkout.js/verify-three-ds) lists sibling order IDs
        // ms-api already marked is_paid for along with this one. The local orders snapshot
        // was cached before payment and never gets refreshed for them, so without this we'd
        // treat successfully-paid siblings as still unpaid and wrongly bounce to the failed
        // page. Only orders outside that list can be genuinely unpaid (e.g. the one-at-a-time
        // PayOrderModal retry flow, which never sends additional_orders).
        const paidTogetherIds = (this.$route.query.additional_orders || '')
          .split(',')
          .filter(id => id !== '')
        const unpaidOrders = orders.filter(order => (
          order.connection_order_id !== this.$route.params.orderId &&
          !paidTogetherIds.includes(String(order.id)) &&
          !order.is_paid
        ));

        if (unpaidOrders.length) {
          localStorage.setItem('shop/order/last-placing-orders-data', JSON.stringify(unpaidOrders));
          await this.$router.push({ name: 'checkout-payment-failed' });
        }
      }
      this.loading = false;
    }
  }
}
</script>

<style lang="scss">
  @import '~theme/css/base/text';
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';
  $bg-secondary: color(secondary, $colors-background);
  $color-tertiary: color(tertiary);
  $color-secondary: color(secondary);
  $color-error: color(error);
  $color-white: color(white);
  $color-black: color(black);

  #checkout {
    flex: 1 1 100%;

    .number-circle {
      width: 35px;
      height: 35px;

      @media (max-width: 768px) {
        width: 30px;
        height: 30px;
        line-height: 30px;
      }
    }
    .radioStyled {
      display: block;
      position: relative;
      padding-left: 35px;
      margin-bottom: 12px;
      cursor: pointer;
      font-size: 16px;
      line-height: 25px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
      }

      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        border: 1px solid #11bb2e;

        &:after {
          content: "";
          position: absolute;
          display: none;
          top: 2px;
          left: 2px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: $color-secondary;
        }
      }

      input:checked ~ .checkmark:after {
        display: block;
      }
    }
  }


  .checkout-title {
    margin-bottom: 10px;
    color: #fff;
    @media (max-width: 768px) {
      background-color: $bg-secondary;
    }
  }
  .background{
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
</style>
